import { ref } from "vue";

export const isScreenshotMode = ref(false);
